module.exports = __webpack_public_path__ + "static/scale-model-of-madame-tussauds-washington-dc-in-alexandria-virginia-25900bb0032f856c76a420c57d726b4e.png";